module.exports = __webpack_public_path__ + "static/media/Cart_Page_Icon.fa0ff854.svg";